var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adsense-slot",class:[
    `adsense-slot--${_vm.placement}`,
    { 'adsense-slot--collapsed': _vm.isCollapsed },
  ],attrs:{"data-ad-name":_vm.adName,"data-ad-slot":_vm.adSlot,"data-ad-state":_vm.adState,"aria-label":"Advertisement"}},[_c('ins',{ref:"adElement",staticClass:"adsbygoogle adsense-slot__ins",staticStyle:{"display":"block"},attrs:{"data-ad-client":_vm.client,"data-ad-slot":_vm.adSlot,"data-ad-format":"auto","data-full-width-responsive":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }